export default __webpack_public_path__ + "static/media/NQPHN-commissioned-services-map-icons_Older Persons.3996fbb9.png";